import React, { useRef, useState, useEffect } from "react";
import FreeUser from "../components/FreeUser/FreeUser"
import HassleFree from "../components/HassleFree/HassleFree";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import KeyFeatures from "../components/KeyFeatures/KeyFeatures";
import WhyRexpt from "../components/WhyRexpt/WhyRexpt";
import OurClient from "../components/OurClient/OurClient";
import GetInTouch from "../components/GetInTouch/GetInTouch";
import FAQ from "../components/FAQ/FAQ";
import Footer from "../components/Footer/Footer";
import Modal from "../components/Modal/Modal";
import FreeAccount from "../components/FreeAccount/FreeAccount";
import { client } from "../../lib/SanityConfig";
import {
  fetchHeroSection,
  fetchBadgeSection,
  fetchHowItWorks,
  fetchKeyFeaturesSection,
  fetchWhyRexptSection,
  fetchTestimonialsSection,
  fetchGetInTouch,
  fetchFaqSection,
  fetchFooterSection,
  fetchFooterSection2,
  fetchHeroSection2,
} from "../../lib/SanityQuery";
import FullPageLoader from "../components/Loader";

export function loadRexWidgetScript() {
  const SRC =
    "https://rexpt-chat-widget.vercel.app/index.js?agentId=agent_0498e1599d6ea9e13d09657f79";
  if (document.getElementById("rex-widget-script")) return;

  document.body.classList.add("rex-defer");

  window.__REX_DEFER_SHOW__ = true;

  const s = document.createElement("script");
  s.id = "rex-widget-script";
  s.src = SRC;
  s.async = true;
  s.defer = true;
  s.crossOrigin = "anonymous";
  s.onerror = (e) => console.error("[REX] script load failed", e);
  document.body.appendChild(s);
}
function installRexGuard() {
  if (window.__rexGuardInstalled) return;
  window.__rexGuardInstalled = true;

  if (!document.getElementById("rex-hide-style")) {
    const style = document.createElement("style");
    style.id = "rex-hide-style";
    style.textContent = `
      /* जब तक body पर .rex-defer लगा है, widget का कोई भी DOM/iframe दिखे नहीं */
      body.rex-defer iframe[src*="rexpt"],
      body.rex-defer iframe[src*="rexpt-chat-widget"],
      body.rex-defer [id*="rex"],
      body.rex-defer [class*="rex"],
      body.rex-defer [id*="chat-widget"],
      body.rex-defer [class*="chat-widget"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  const hidden = new Set();
  const matchRex = (node) => {
    const t = (v) => (v || "").toString().toLowerCase();
    if (node.tagName === "IFRAME") {
      const src = t(node.src);
      if (
        src.includes("rexpt") ||
        src.includes("rexpt-chat-widget") ||
        src.includes("vercel.app")
      )
        return true;
    }
    const id = t(node.id);
    const cls = t(node.className);
    return (
      id.includes("rex") ||
      id.includes("chat-widget") ||
      cls.includes("rex") ||
      cls.includes("chat-widget")
    );
  };

  const hideNode = (node) => {
    if (!(node instanceof HTMLElement)) return;
    if (matchRex(node) && !hidden.has(node)) {
      node.style.display = "none";
      node.style.visibility = "hidden";
      node.style.opacity = "0";
      node.style.pointerEvents = "none";
      hidden.add(node);
    }
  };

  document.querySelectorAll("*").forEach(hideNode);

  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes.forEach((n) => {
        if (n instanceof HTMLElement) {
          hideNode(n);
          n.querySelectorAll?.("*")?.forEach?.(hideNode);
        }
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  window.__unhideRexNodes = () => {
    document.body.classList.remove("rex-defer");
    hidden.forEach((n) => {
      try {
        n.style.display = "";
        n.style.visibility = "";
        n.style.opacity = "";
        n.style.pointerEvents = "";
      } catch {}
    });
    hidden.clear();
    mo.disconnect();
  };
}
export function showRexWidget() {
  if (typeof window.__unhideRexNodes === "function") window.__unhideRexNodes();
  else document.body.classList.remove("rex-defer");

  window.__REX_DEFER_SHOW__ = false;
  if (typeof window.__rexShowWidget === "function") {
    window.__rexShowWidget({ mode: "modal" });
  } else if (typeof window.openReviewWidget === "function") {
    window.openReviewWidget();
  } else if (typeof window.createReviewWidget === "function") {
    window.createReviewWidget();
  }
}

const LandingPage = () => {
  const heroRef = useRef(null);
  const freeUserRef = useRef(null);
  const howItWorksRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFloatingButton, setShowFloatingButton] = useState(false);
  const [heroSection, setHeroSection] = useState(null);
  const [badgeSection, setBadgeSection] = useState(null);
  const [howitworks, sethowitworks] = useState(null);
  const [keyfeatureSectiondata, setKeyFeatureSection] = useState(null);
  const [rexptSectionPage, setRexptSectionPage] = useState(null);
  const [testimonialSection, setTestimonialSection] = useState(null);
  const [getInTouch, setgetInTouch] = useState(null);
  const [faq, setFaq] = useState(null);
  const [footer, setFooter] = useState(null);
  const [gtVersion, setGtVersion] = useState(0);

    useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;

      if (window.innerWidth <= 1020 && scrollPercent >= 10) {
        setShowFloatingButton(true);
      } else {
        setShowFloatingButton(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  useEffect(() => {
    const onLangChange = () => setGtVersion((v) => v + 1);
    window.addEventListener("gt:changed", onLangChange);
    return () => window.removeEventListener("gt:changed", onLangChange);
  }, []);

  // useEffect(() => {
  //   installRexGuard();
  //   loadRexWidgetScript();
  // }, []);

  // useEffect(() => {
  //   const el = heroRef.current;
  //   if (!el) return;
  //   const io = new IntersectionObserver(
  //     ([entry]) => {
  //       if (entry.intersectionRatio < 0.98) {
  //         showRexWidget();
  //         io.disconnect();
  //       }
  //     },
  //     { threshold: 0.98 }
  //   );
  //   io.observe(el);
  //   return () => io.disconnect();
  // }, []);

  // useEffect(() => {
  //   showRexWidget();
  // }, []);

//   useEffect(() => {
//   installRexGuard();        
//   loadRexWidgetScript();   
// }, []);



useEffect(() => {
  const el = freeUserRef.current;
  if (!el) return;
  const io = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        showRexWidget();   
        io.disconnect();
      }
    },
    { threshold: [0.5] }
  );
  io.observe(el);
  return () => io.disconnect();
}, []);



  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [
          heroData,
          badgeData,
          howitworksdata,
          fetchKeyFeaturesSectiondata,
          rexptSectionData,
          testimonialdata,
          getInTouchData,
          faqdata,
          footerData,
        ] = await Promise.all([
          client.fetch(fetchHeroSection2),
          client.fetch(fetchBadgeSection),
          client.fetch(fetchHowItWorks),
          client.fetch(fetchKeyFeaturesSection),
          client.fetch(fetchWhyRexptSection),
          client.fetch(fetchTestimonialsSection),
          client.fetch(fetchGetInTouch),
          client.fetch(fetchFaqSection),
          client.fetch(fetchFooterSection2),
        ]);
        if (!mounted) return;
        setHeroSection(heroData);
        setBadgeSection(badgeData);
        sethowitworks(howitworksdata);
        setKeyFeatureSection(fetchKeyFeaturesSectiondata);
        setRexptSectionPage(rexptSectionData);
        setTestimonialSection(testimonialdata);
        setgetInTouch(getInTouchData);
        setFaq(faqdata);
        setFooter(footerData);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (loading) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [loading]);

  const scrollToHowItWorks = () => {
    if (window.innerWidth > 1020) {
      const element = howItWorksRef.current;
      if (element) {
        const yOffset = 400;
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    } else {
      setIsModalOpen(true);
    }
  };



  if (loading) return <FullPageLoader />;
  return (
    <>
      <div>
        <div ref={freeUserRef}>
          {heroSection?.enabled === true && (
            <FreeUser
              scrollToHowItWorks={scrollToHowItWorks}
              heroSection={heroSection}
            />
          )}
        </div>
        {badgeSection?.enabled === true && (
          <HassleFree badgeSection={badgeSection} />
        )}
        {howitworks?.enabled === true && (
          <div ref={howItWorksRef}>
            <HowItWorks howitworks={howitworks} />
          </div>
        )}
        {keyfeatureSectiondata?.enabled === true && (
          <KeyFeatures
            scrollToHowItWorks={scrollToHowItWorks}
            keyfeatureSectiondata={keyfeatureSectiondata}
          />
        )}
        {rexptSectionPage?.enabled === true && (
          <WhyRexpt
            scrollToHowItWorks={scrollToHowItWorks}
            rexptSectionPage={rexptSectionPage}
          />
        )}
        {testimonialSection?.enabled === true && (
          <OurClient testimonialSection={testimonialSection} />
        )}
        {getInTouch?.enabled === true && (
          <GetInTouch
            scrollToHowItWorks={scrollToHowItWorks}
            getInTouch={getInTouch}
          />
        )}
        {faq?.enabled === true && (
          <FAQ
            scrollToHowItWorks={scrollToHowItWorks}
            faq={faq}
            key={gtVersion}
          />
        )}
        {footer?.enabled === true && <Footer footer={footer} />}
        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          bgColor="transparent"
          boxShadow="unset"
          closeColor="#fff"
        >
          <FreeAccount coming = "6" closeModal = {()=>setIsModalOpen(false)} />
        </Modal>

        {showFloatingButton && (
          <div className="floatingButton" onClick={() => setIsModalOpen(true)}>
            <img src="Svg/join-rexpt-mob-new01.svg" alt="join-rexpt" />
          </div>
        )}
      </div>

      {/* <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        bgColor="transparent"
        boxShadow="unset"
        closeColor="#fff"
        maxWidth="500px"
      >
        <FreeAccount  />
      </Modal> */}
    </>
  );
};

export default LandingPage;
